import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import SettingsSection from '@/components/SettingsSection';
import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function PasswordRecoverySettings() {
  useUiLanguage();
  const { user, studio } = useAuth();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const send = async () => {
    if (busy) return;
    setBusy(true); setError(""); setMessage("");
    try {
      const result = await api.post("/auth/password-recovery/request-current");
      setMessage(result.message);
    } catch (e) { setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <SettingsSection title={tr("Accesso e sicurezza")} subtitle={tr("Email di accesso e recupero della password")}>
    <div className="mt-4 space-y-3 text-sm">
      <p>{studio?.name}</p><p className="break-all">{tr("Email di accesso:")} <strong>{user?.email}</strong></p>
      <p className="text-muted-foreground">{tr("Per impostare una nuova password, anche se non ricordi quella attuale, ricevi un link su questa email. Prima di confermare vedrai esattamente a quale accesso si applica.")}</p>
      <p className="text-muted-foreground">{tr("Richiedere il link non cambia la password e non interrompe questo accesso.")}</p>
      <Button type="button" className="min-h-12 h-auto w-full whitespace-normal py-3 sm:w-auto" disabled={busy} onClick={send}>{busy ? tr("Richiesta in corso…") : tr("Ricevi link per cambiare password")}</Button>
      {message && <p role="status">{message}</p>}{error && <p role="alert" className="text-destructive">{systemText(error)}</p>}
    </div>
  </SettingsSection>;
}
